import { useContext, useEffect, useMemo, useState } from "react";
import { ListPageProps } from "./Index";
import { Operation, TableHeaders } from "../../../../../utils/Enum.types";
import { Title } from "../../../../../stories/Title/Title";
import { TableHeaderProps } from "../../../../../utils/types";
import {
  HEADER_TEXT_ALIGN,
  SLNO_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../styles/Variables";
import { GridColDef, GridValidRowModel } from "@mui/x-data-grid-pro";
import Edit from "../../../../../images/EditProfile.svg";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import DeleteModal from "../../../../../customComponents/DeleteModal";
import { GetStockCategories } from "./queries/queries";
import {
  AtsStckCategoryEdge,
  AtsStckCategoryOrderField,
  DeleteCategoryByIdResult,
  DeleteCategoryByIdVars,
  GetStockCategoriesResult,
  GetStockCategoriesVars,
} from "./queries/types";
import { useLazyQuery, useMutation } from "@apollo/client";
import { getModifiedScrollHeight } from "../../../../../utils/UtilFunctions";
import {
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  emptyMessage,
} from "../../../../../utils/constants";

import useUrlParams from "../../../../../customHooks/useUrlParams";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import { AppContext } from "../../../../../context/context";
import { payloadTypes } from "../../../../../context/reducer";
import { DeleteStockCategory } from "./queries/mutations";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import Delete from "../../../../../images/Delete.svg";
import LoadingModal from "../../../../pages/LoadingModal";

const List = ({ setOperation, setMessage }: ListPageProps) => {


  const { customer_id } = useUrlParams();
  const [searchData, setSearchData] = useState("");
  const { state, dispatch } = useContext(AppContext);

  const groupInput = document.getElementsByName("groupName");
  const [GetCategories, { data, loading, fetchMore }] = useLazyQuery<
    GetStockCategoriesResult,
    GetStockCategoriesVars
  >(GetStockCategories);
  const { user_details } = useLoggedInUserDetails();

  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [categories, setCategories] = useState<AtsStckCategoryEdge[]>([]);
  const [rows, setRows] = useState<GridValidRowModel[]>([]);
  const [deleteModal, setDeleteModal] = useState(false);

  const [DeleteCategory, { loading: deleteLoading }] = useMutation<
    DeleteCategoryByIdResult,
    DeleteCategoryByIdVars
  >(DeleteStockCategory, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const dynamicHeaders: TableHeaderProps[] = [
    {
      headerName: "Sl",
      field: "id",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
    },
    {
      headerName: `Category Description`,
      field: "categoryName",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      flex: 1,
      hideable: false,
    },
  ];
  const columns: GridColDef[] = [
    ...dynamicHeaders,
    {
      headerName: TableHeaders.ACTION,
      field: "actions",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      renderCell: (params) => {
        return (
          <>
            <img
              src={Edit}
              alt=""
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_CATEGORY_ID,
                  payload: {
                    categoryId: params.row.cat_id,
                  },
                });
                if (groupInput.length) groupInput[0].focus();
                setOperation(Operation.UPDATE);
              }}
            />
            <img
              src={Delete}
              alt=""
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_CATEGORY_ID,
                  payload: {
                    categoryId: params.row.cat_id,
                  },
                });
                setDeleteModal(!deleteModal);
              }}
            />
          </>
        );
      },
    },
  ];

  const HandleDelete = async () => {
    try {
   
        setDeleteModal(!deleteModal);
        DeleteCategory({
          variables: {
            
            category_id: state.categoryId,
            user_details,
          },
          refetchQueries: [
            {
              query: GetStockCategories,
              variables: {
                after: null,
                customer_id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsStckCategoryOrderField.CATEGORY_NAME,
                },
              
                name: searchData,
              },
            },
          ],
        }).then(({ data }) => {
          if (data) {
            setMessage({
              flag: true,
              message: "Category Deleted Sucessfully",
              operation: Operation.DELETE,
            });
          }
        });
      
    } catch (err) {
      console.error((err as Error).message);
    }
  };
  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetStockCategories.edges;
              const pageInfo = fetchMoreResult.GetStockCategories.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetStockCategories.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetStockCategories: {
                  edges: [...categories, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetStockCategories.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetStockCategories.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = categories.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setCategories(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            item_desc: node.categoryName,
            categoryName: node.categoryName,
            manufacturer_desc: "",
            unit_desc: "",
            no_of_decimals: 0,
            cat_id: node.id,
          }))
        );
      } else {
        setCategories(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            item_desc: node.categoryName,
            categoryName: node.categoryName,
            manufacturer_desc: "",
            unit_desc: "",
            no_of_decimals: 0,
            cat_id: node.id,
          }))
        );
      }
      setEndCursor(data.GetStockCategories.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    if ( customer_id) {
      GetCategories({
        variables: {
          after: null,
          customer_id,
          first: ROWS_PER_PAGE,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsStckCategoryOrderField.CATEGORY_NAME,
          },
          name: searchData,
        },
      });
    }
  }, [customer_id, GetCategories, searchData]);

  return (
    <>
      <div className="master-data__list">
        <Title variant="subtitle1">{`List of Category`}</Title>
        <div className="master-data__list--tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            // onCellClick={(params) => {
            //   if (params.field === "months") {
            //     setViewModal(!viewModal);
            //     handleFilterMonthDetails(params.row.month_id);
            //   }
            // }}
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
      </div>
      <DeleteModal
        id={state.categoryId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={HandleDelete}
      />
      <LoadingModal flag={deleteLoading || loading} />
    </>
  );
};

export default List;
